// extracted by mini-css-extract-plugin
module.exports = {"legend":"lineChart_legend__3hV6L","color":"lineChart_color__3oNrl","label":"lineChart_label__20Wjl","chart":"lineChart_chart__1zRiE"};